export default "__VITE_ASSET__CKSZwe2Z__"